export default {
  primaryColor: '#FF6B38',
};
